// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FormErrors_wrapper"};